var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 39.9304C25.3043 39.9304 39.9791 39.9298 39.9791 39.9298C39.9791 39.9298 40 25.2859 40 20C40 14.7142 39.9796 20.0001 39.9796 0.0697178C19.991 0.0696837 25.3043 0.0697159 20 0.0697159C14.6957 0.0697159 20 0.0697426 0.020895 0.0697313C0.00158118 20 0 14.7142 0 20C0 25.2859 0.0225756 20 0.0212771 39.9298C20 39.9304 14.6957 39.9304 20 39.9304ZM17.95 29.9154V20.9966H15V17.4257H17.95V14.7683C17.95 11.6957 19.75 10.0349 22.3667 10.0349C23.6167 10.0349 24.7 10.1345 25 10.1677V13.3732H23.1833C21.7667 13.3732 21.4833 14.0874 21.4833 15.1171V17.4091H24.8833L24.4333 20.9799H21.5V29.9652L17.95 29.9154Z",
    fill: "#5C79B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.0be0477c4b2168bdb53b38eace4c2456.svg";
export { ForwardRef as ReactComponent };